import { TBSExtraItemReturnEntity } from "../../../../interface/tbs-tracker/tbs-store";
import ReceiverImageThumbs from "./receiver-image-thumbs";

/** The returns made after the TBS was received, newest first: when / who, what went back, the remarks and the photos. */
export default function ReturnedExtraItemsList({ returns }: { returns: TBSExtraItemReturnEntity[] }) {
    return (
        <>
            {returns.map((item) => (
                <div key={item._id} className="mb-3" data-testid="extra-item-return">
                    <div className="fw-medium mb-1">
                        {item.returnedAt}
                        {item.returnedBy ? ` - ${item.returnedBy}` : ""}
                        {item.returnedQty ? ` - ${item.returnedQty} ${item.returnedQty === 1 ? "item" : "items"} returned` : ""}
                    </div>
                    {item.items && item.items.length > 0 && (
                        <small className="text-muted d-block">
                            {item.items.join("; ")}
                        </small>
                    )}
                    <small className="text-muted d-block mb-2" style={{ whiteSpace: "pre-wrap" }}>
                        {item.notes}
                    </small>
                    <ReceiverImageThumbs urls={item.images} />
                </div>
            ))}
        </>
    );
}
